export default function () {
  return Math.min(0, this.scaledRotatedInternalImageHeightDifference)
}
